export default {
  namespaced: true,
  unit_deactivation_catalog: {
    title: "Desactivación de Instalaciones |Desactivación de Instalaciones",
    name: "Nombre",
    description: "Descripción",
    user_reactivation: "Usuario que reactivo",
    user_deactivation: "Usuario que desactivo",
    deactivation_reason: "Razón de desactivación",
    attachments: "Archivos adjuntos",
  },
};

